module.exports = __webpack_public_path__ + "static/logo-mark-4b22008406855d7792e9785b99e04d37.svg";